import { PaymentFlowResult } from '@/Services/PaymentMethod/types';

// Backend contract: PaymentMethodController / TeamController return HTTP 422 with this type_code
// when Stripe Tax location validation (tax.validate_location) rejects the billing address.
export const TAX_LOCATION_ERROR_TYPE = 'invalid_tax_location';

// Billing-address section id on the checkout page (PaymentForm.vue) — used so the error alert's
// "Fix it" button scrolls the user to the address fields.
const BILLING_ADDRESS_CONTAINER = 'checkoutBillingAddressContainer';

/**
 * Whether a caught axios error is the backend's Stripe Tax location-validation failure
 * (HTTP 422, `type_code: invalid_tax_location`). Single source of truth for that contract check,
 * shared by the checkout mapper below and the billing-update flow (`auth/updateTeam`).
 */
export function isTaxLocationValidationError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { type_code?: string } } })?.response;

  return response?.status === 422 && response?.data?.type_code === TAX_LOCATION_ERROR_TYPE;
}

/**
 * Map a caught axios error to a checkout error result when it is the Stripe Tax location-validation
 * failure. Returns `null` for any other error so the caller keeps its existing handling.
 *
 * This is an expected, user-fixable error (bad billing address), so callers should return it
 * without reporting to Sentry.
 */
export function mapTaxLocationValidationError(error: unknown): PaymentFlowResult['error'] | null {
  if (!isTaxLocationValidationError(error)) {
    return null;
  }

  return {
    message_key: 'checkout.form.invalid_billing_address',
    container: BILLING_ADDRESS_CONTAINER,
  };
}
